import Vue from 'vue';
import Vuex from 'vuex';
// import router from '../router';
import http from '../utils/http.util';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: '',
    userId: localStorage.getItem('userId'),
    user: JSON.parse(localStorage.getItem('user')) || null,
    roles: JSON.parse(localStorage.getItem('roles')) || [],
    isTokenRefreshing: false
  },

  mutations: {
    authUser(state, authData) {
      state.accessToken = authData.accessToken;
      state.userId = authData.userId;
      localStorage.setItem('userId', authData.userId);
    },
    storeUser(state, userData) {
      state.user = userData.user;
      state.roles = userData.roles;
      localStorage.setItem('user', JSON.stringify(userData.user));
      localStorage.setItem('roles', JSON.stringify(userData.roles));
    },
    discardSession(state) {
      state.accessToken = '';
      state.userId = null;
      state.user = null;
      state.roles = [];
      localStorage.clear();
    },
    setTokenRefresh(state, isRefreshing) {
      state.isTokenRefreshing = Boolean(isRefreshing);
    },
    removeAccessToken(state) {
      state.accessToken = null;
    }
  },

  actions: {
    async login({ commit }, loginData) {
      // Attempt to login
      const response = await http({
        method: 'post',
        url: '/auth/login',
        data: {
          username: loginData.username,
          password: loginData.password
        }
      });

      const { accessToken, user } = response.data;
      commit('authUser', { accessToken, userId: user.id });
      commit('storeUser', { user, roles: user.roles });
    },

    async logout({ commit }) {
      await http.post('/auth/logout');

      commit('discardSession');
    }
  },

  getters: {
    isLoggedIn({ accessToken }) {
      return Boolean(accessToken);
    },

    isAdmin({ roles }) {
      return roles.includes('admin');
    }
  }
});
